import { Box, SxProps } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

interface PageProps {
  innerWrapperSx?: SxProps;
  /**
   * Overrides the tenant page background. Only used by the bootstrap loader,
   * which renders before the tenant colors are known.
   */
  backgroundColor?: string;
}

export const Page: FC<PropsWithChildren<PageProps>> = ({
  children,
  innerWrapperSx: sx,
  backgroundColor = 'background.default',
}) => {
  return (
    <Box display="flex" sx={{ backgroundColor, width: '100%' }} minHeight="calc(100vh - 110px)">
      <Box sx={{ maxWidth: '800px', margin: 'auto', py: { xs: 2, md: 8 }, px: { xs: 1, md: 0 }, ...sx }}>
        <Box sx={{ borderRadius: 2, overflow: 'hidden', boxShadow: 3 }}>
          <Box
            sx={{
              textAlign: 'center',
              backgroundColor: 'background.paper',
              paddingX: { xs: 2, md: 18 },
              paddingY: { xs: 4, md: 8 },
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
